import { useDispatch } from "react-redux";
import { authorSearch, categorySearch } from "../redux/blog/actions";

const Blog = ({ blog }) => {
    const dispatch = useDispatch();
    const { title, category, blogImage, author: {id : authorId, name , image: authorImage }, totalReadTime, dateTime } = blog;
    
    const handleCategorySearch = () => {
        dispatch(categorySearch(category));
    };

    const handleAuthorSearch = () => {
        dispatch(authorSearch(authorId));
    };

    return (
        <div
        className="flex flex-col rounded-lg shadow-lg overflow-hidden"
    >
        <div className="flex-shrink-0">
            <img
                className="h-48 w-full object-cover"
                src={blogImage}
                alt=""
            />
        </div>

        <div
            className="flex-1 bg-white p-6 flex flex-col justify-between"
        >
            <div className="flex-1">
                <p className="text-sm font-medium text-indigo-600" onClick = {handleCategorySearch}>
                    <span
                        className="cursor-pointer inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800"
                    >
                        { category }
                    </span>
                </p>
                <a href="#" className="block mt-1">
                    <p
                        className="text-xl font-semibold text-gray-900"
                    >
                        { title }
                    </p>
                </a>
            </div>
            <div className="mt-6 flex items-center">
                <div className="cursor-pointer flex-shrink-0" onClick={handleAuthorSearch}>
                    <img
                        className="h-10 w-10 rounded-full"
                        src={authorImage}
                        alt={authorImage}
                    />
                </div>
                <div className="ml-3" onClick={handleAuthorSearch}>
                    <p
                        className="cursor-pointer text-sm font-medium text-gray-900 hover:underline"
                    >
                        {name}
                    </p>
                    <div
                        className="flex space-x-1 text-sm text-gray-500"
                    >
                        <time dateTime="2020-03-16">
                            { dateTime } 
                        </time>
                        <span aria-hidden="true">
                            &middot;
                        </span>
                        <span> {totalReadTime} min read </span>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
};

export default Blog;